// extracted by mini-css-extract-plugin
module.exports = {"selectContainer":"SelectHitsPerPage_selectContainer__S71W7","leftToRight":"SelectHitsPerPage_leftToRight__5oWs5"};